import HostedCheckout from "./HostedCheckout";

/**
 * E-wallet top-up through CIB Hosted Checkout.
 * Used by the E-Wallet page (src/components/Students/ewallet.tsx).
 */

interface Props {
  /** EGP to add to the wallet. */
  amount: number;
  /** Student whose wallet is charged. */
  std: string | number;
  onFinish: (result: any) => void;
  /** Ignored - the server sets the payment code and description. */
  code?: string;
  serviceName?: string;
}

export default function DoPayment({ amount, std, onFinish }: Props) {
  return (
    <HostedCheckout
      endpoint="payment/wallet/createsession.php"
      payload={{ amount, student_id: std }}
      onFinish={onFinish}
    />
  );
}
